import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { Location } from 'history';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Prompt } from 'react-router';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';

interface IProps {
  intercept: boolean;
  showModal: boolean;
  onConfirm: () => Promise<void>;
  onKeepDraft: () => void;
  onCancel: () => void;
  onBlockedNavigation: (location: Location) => boolean;
  loaderKey?: string;
}

export const PublishProjectNavigateAwayConfirmationModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const handleConfirm = (): void => {
    void props.onConfirm();
  };

  return (
    <>
      <Prompt
        when={props.intercept}
        message={props.onBlockedNavigation}
      />

      <S_Modal
        className='confirmation-dialog'
        isOpen={props.showModal}
        toggle={props.onCancel}
        headerText={t('project_draft_modal_header')}
        buttons={
          <>
            <Button
              variant='outlined'
              color={'neutral'}
              onClick={props.onCancel}
            >
              {t('cancel')}
            </Button>
            <Button
              variant='outlined'
              color={'neutral'}
              onClick={props.onKeepDraft}
            >
              {t('no_keep_as_draft')}
            </Button>
            <ButtonWithLoader
              onClick={handleConfirm}
              loaderKey={props.loaderKey}
            >
              {t('yes_publish')}
            </ButtonWithLoader>
          </>
        }
      >
        <div className='confirmation-content'>
          <div>{t('project_draft_modal_text')}</div>
        </div>
      </S_Modal>
    </>
  );
});
